import React from 'react';
import { getStatusColor } from '../history.service';

const ClientIcon = ({ status, clientEmail }) => {
  return (
    <div
      className="icon flex-container justify-center align-center"
      style={{ backgroundColor: getStatusColor(status) }}>
      {clientEmail?.charAt(0).toUpperCase()}
      <style jsx>
        {`
          .icon {
            background-color: var(--primary-color);
            color: white;
            fontSize: '24px'
            padding: 10px;
            width:30px;
            height:30px;
            border-radius: 50%;
          }
        `}
      </style>
    </div>
  );
};

export default ClientIcon;
